import { compareString } from "./utils";
import { THIC, WIFI_EXTENDER, WHOLE_HOME_WIFI,ADDITIONAL_WIFI_EXTENDER } from '../../../shared/utils/Constants';

const formatProductName = (name: any) => {
  if (name !== undefined && name !== '') {
    const firstDigit: any = name?.match(/\d/);
    const indexed = name?.indexOf(firstDigit);
    return indexed;
  }
}

const isPrimaryWifiExtender = (productName: any) =>
  !compareString(productName, "additional") && compareString(productName, "extender");

const getPostpaidLineItemName = (item: any, wifiCount: any) => {
  if (isPrimaryWifiExtender(item?.productName)) {
    return `${item?.productName} - ${wifiCount} count`;
  }

  if (compareString(item?.productName, "whole") && wifiCount > 1) {
    return item?.productName + "- 2 extenders";
  }

  return item?.productName;
};

const getPostpaidLineItemPrice = (item: any, internetPrice: any, wifiCount: any) => {
  const isInternetProduct = compareString(item?.productName, "internet");
  const lineItemPrice = Number(item?.displayLineItemPrice);
  const hasLineItemPrice = item?.displayLineItemPrice !== undefined && item?.displayLineItemPrice !== null && Number.isFinite(lineItemPrice);

  if (isInternetProduct && hasLineItemPrice) {
    return `$${Math.abs(lineItemPrice).toFixed(2)}`;
  }

  const totalDiscount = Number(item?.displayTotalDiscount || 0);

  if (totalDiscount !== 0) {
    return `$${totalDiscount.toFixed(2)}`;
  }

  if (isPrimaryWifiExtender(item?.productName)) {
    const calculatedPrice = (Number(internetPrice || 0) / Number(item?.quantity || 0)) * Number(wifiCount || 0);
    return `$${calculatedPrice.toFixed(2)}`;
  }

  return `$${Math.abs(internetPrice)?.toFixed(2)}`;
};

export const shouldApplyAffinityDiscount = (product: any, existingOrderDetails: any, cardType: string, productExist: boolean, AffinityApplicable?: boolean, has8gOR5G?: boolean, new8GPlan?: any, new5GPlan?: any, isSpeedDowngradingAllowed?: any, isPostPaidFiberUser?: boolean) => {
  const isAffinityDiscount = existingOrderDetails?.discountPlans?.find((element:any) => element?.productName === "Affinity Discount")?.affinityOccupation;
  const productServiceLevel = product?.offerResponse?.offerDetails?.serviceLevel;
  const existingServiceLevel = existingOrderDetails?.standardPlans?.find((element1:any) => element1?.planName?.includes("Internet"));
  const priceLockAvailable = existingOrderDetails?.priceLockC;
  
 
  // if(product?.speed === 8000000 && !productExist  && !has8gOR5G){ 
  //   return "newPlan8G"
  // }
  // if(product?.speed === 5000000 && !productExist  && !has8gOR5G){ 
  //   return "newPlan5G"
  // }
  if (!productExist && cardType === "internet" && !isSpeedDowngradingAllowed && isPostPaidFiberUser){
      return "isSpeedDowngradingRestricted";
    }
  // else if (
  //   (isAffinityDiscount && isAffinityDiscount?.length && isAffinityDiscount !== null &&
    
  //   (cardType !== "voice" && cardType !== "noVoice" && !productExist && product?.speed !== 8000000 ))
  // ) {
  //   return "discountChanged";
  // }
   else if (isAffinityDiscount && isAffinityDiscount?.length && isAffinityDiscount !== null && cardType !== "voice" && cardType !== "noVoice"  && !productExist && !AffinityApplicable) {
    return "notEligible";
  }
  // else if( (cardType !== "voice" && cardType !== "noVoice")  && (existingServiceLevel?.planName?.includes("200") || existingServiceLevel?.planName?.includes("500")) ) {
  //   return "loosingPlanSpeedTiers";
  // } 
  else if ((priceLockAvailable && priceLockAvailable !== null) &&
    (!productExist && cardType !== "voice" && cardType !== "noVoice")
  ) {
    return "nonAffinityPriceLock";
  }
  else if (cardType === "voice" || cardType === "noVoice") {
    return "voice";
  } else if (cardType !== "voice") {
    return "default";
  }
};

function convertDollarPriceNoTrailingZeros(value:any) {
  const formattedValue = value?.toString(10);
  return `$${formattedValue}`;
}

export const getSelectedProductDetail = (
  selectedProduct: any,
  cardType: string
): any => {
  if (cardType === "internet") {
    const { offerDetails } = selectedProduct?.offerResponse || { offerDetails: {} };
    return offerDetails;
  }
  return selectedProduct;
};

export const getProductDetail = (simplifiedProduct: any, product: any, cardType: string): any => {
  if (cardType === "internet") {
    return simplifiedProduct?.offerResponse?.offerDetails || {};
  }
  return product;
};

function extractGigProducts(result: any, flag: any) {
  if (!result?.productDetails) {
    return [];
  }

  return result?.productDetails?.filter((detail:any) =>
      detail?.offerResponse?.offerDetails?.productName?.toLowerCase().includes(flag?.toLowerCase())
    )
    ?.filter((detail:any) => detail?.offerResponse?.offerDetails?.affinity?.isAffinityApplicable)
    ?.map((detail:any) => ({
      
      name: detail?.offerResponse?.offerDetails?.affinity?.discountName,
      amount: detail?.offerResponse?.offerDetails?.priceResult?.length > 0 &&  detail?.offerResponse?.offerDetails?.priceResult[0]?.productCharge - detail?.offerResponse?.offerDetails?.priceResult[0]?.discountCharge ,
    }));
}
export const getFilteredItems = (
  cartResponse: any,
  existingOrderDetails: any,
  voiceRemoved: boolean,
  currentProduct: any,
  csm: any,
  productRes: any,
  planDetailsData?: any,
  selectedInternetProduct?:any,
  isAffinityApplicable?: any,
  selectedInternetChanged?: boolean,
  wifiCount?:any
) => {
  const keywords = ["fiber", "brightspeed now", "voice", "tech",THIC,WIFI_EXTENDER, WHOLE_HOME_WIFI,"protection"];
  let result: any[]= [];
   const existingInternet = existingOrderDetails?.standardPlans?.find((element:any) => (element?.productName?.toLowerCase()?.includes("internet") || element?.planName?.toLowerCase()?.includes("brightspeed now")));
  let sameProd= selectedInternetProduct && Array.isArray(selectedInternetProduct) && selectedInternetProduct.length > 0 ? (selectedInternetProduct[0]?.productName?.toLowerCase()?.includes(existingInternet?.planName?.toLowerCase())): selectedInternetChanged === false ? true : false;
  const isAffinityDiscountApplicable = existingOrderDetails?.discountPlans?.find((element:any) => element?.productName === "Affinity Discount")?.affinityOccupation;
  // Determine the source of items based on voiceRemoved
  // below commneted code is not required aa cancel voice condtion changed from API end
  // const source = voiceRemoved
  //   ? [currentProduct?.offerResponse?.offerDetails]
  //   : cartResponse?.lineItems;


  const existingWifiExtender = existingOrderDetails?.additionalPlans?.find((element:any) => (element?.additionalPlanName?.toLowerCase()?.includes(WIFI_EXTENDER?.toLowerCase()) && !element?.additionalPlanName?.toLowerCase()?.includes(ADDITIONAL_WIFI_EXTENDER?.toLowerCase())));

  const source = cartResponse?.lineItems;

  // Filter items from cartResponse or currentProduct based on keywords
  const availableFromCart = source?.filter((item: any) =>
    keywords?.some((keyword) => item?.productName?.toLowerCase().includes(keyword.toLowerCase()))
  );

  // Check for missing keywords in cart and handle them
  keywords?.forEach((keyword) => {
    const keywordInCart = availableFromCart?.some((item: any) =>
      item?.productName?.toLowerCase()?.includes(keyword?.toLowerCase())
    );

    // If not found in availableFromCart, look in existingOrderDetails
    if (!keywordInCart) {
      const sourceType = (keyword === "tech" || keyword===THIC ||  keyword === "protection" || keyword===WIFI_EXTENDER || keyword===WHOLE_HOME_WIFI) ? "additionalPlans" :  "standardPlans";
      
      let additonalPlan = existingOrderDetails?.additionalPlans
      additonalPlan = additonalPlan && additonalPlan.length ? additonalPlan.reduce((acc: any, item: any) => {
        const found = acc.find((obj: any) => obj?.additionalPlanName === item?.additionalPlanName);
        if (found) {
          found.count++
        } else {
          acc.push({ ...item, count:item?.quantity?item.quantity:1 })
        }
        return acc;
      }, []) : [];
     
      const planSource =
        (keyword === "tech" || keyword === THIC || keyword === "protection" || keyword===WIFI_EXTENDER || keyword===WHOLE_HOME_WIFI)
          ? additonalPlan
          : existingOrderDetails?.standardPlans;
      const plan = planSource?.find((plan: any) =>
        plan?.ratePlanName?.toLowerCase()?.includes(keyword.toLowerCase())
      );
      
      if (plan && !(keyword === "voice" && voiceRemoved)) {
        result.push({
          name: compareString(plan?.ratePlanName,"whole")? (wifiCount>1)?plan?.ratePlanName + ' - 2 extenders':plan?.ratePlanName  : (compareString(plan?.productName, "wifi extender") && !compareString(plan?.productName, "Additional wifi extender")) ? `${plan?.productName}` : plan?.ratePlanName, //plan?.ratePlanName?.includes(BRIGHT_SPEED_THTS) ? plan?.ratePlanName?.replace("Brightspeed", "") : plan?.ratePlanName,
 
          // discount:plan?.discount,
          // discountedPrice:     plan?.additionalPlanPrice - plan?.discount,
          // discountName:     plan?.allDiscount,
          // validity:plan?.validity,
          price: sourceType !== "additionalPlans" ? `$${Math.abs(plan?.planPrice)?.toFixed(2)}` :  `$${(Math.abs(plan?.additionalPlanPrice)?.toFixed(2))}`,
        });
      }

    if (Array.isArray(plan?.allDiscount) && plan.allDiscount.length > 0) {
      plan.allDiscount.forEach((item: any) => {
        if (!compareString(item?.planName, "one month free") &&
        !item?.planName?.toLowerCase()?.includes("first month free-wifi extender")) {
        result.push({
          name:item?.planName,
          price:`-$${Number(item?.discountAmount || 0)?.toFixed(2)}`,
          validity:item?.effectiveEndDate
        });
    }
      });
    }

    if (Array.isArray(plan?.discount) && plan?.discount?.length > 0) {
      plan?.discount?.forEach((item: any)=> {
        if(item?.Disccode?.toLowerCase()?.includes("3mf")) {
       result.push({
          name:"Three Months Free"+ " - "+item?.productName,
          price:`-$${Number(item?.Discvalue || 0)?.toFixed(2)}`,
          validity:""+item?.Discenddate?.replace(/\./g, "/"),
          type:"discount",
          code:"3mf"
      })
          }
        });
    }

  }

  });
  
    if (planDetailsData && Array.isArray(planDetailsData) && planDetailsData?.length && (sameProd)) {
      planDetailsData.forEach((itemData: any) => {
        const exists = result?.some((entry) => entry?.name === itemData?.planName);
        if (!exists) {
          result.push({
            name: itemData?.planName,
            price: `-$${Math.abs(itemData?.planDiscount)?.toFixed(2)}`,
          });
        }
      });
    }


  // Add all matching items from the cart to the result
  availableFromCart?.forEach((item: any) => {
    if (voiceRemoved && item?.productName?.toLowerCase().includes("voice")) {
      return;
    }

    if(cartResponse && (compareString(item?.productName,THIC) || compareString(item?.productName,"protection"))  && item.itemActionType==="remove"){
      return;
    }
    if(cartResponse && compareString(item?.productName,"support") && item.itemActionType==="remove"){
      return;
    }
 
     if(wifiCount === 0 && cartResponse && compareString(item?.productName,"wifi extender") && item.itemActionType==="remove"){
      return;
    }
     if(cartResponse && compareString(item?.productName,"whole") && wifiCount===0 && item.itemActionType==="remove"){
      return;
    }
    if(cartResponse && compareString(item?.productName,"additional") &&  item.itemActionType==="remove"){
      return;
    }
    const price = item?.displayLineItemPrice;
    //*********** Below code is not required */
    //const price = voiceRemoved
      // ? item?.priceResult?.length > 0 && item?.priceResult[0]?.productCharge || 0
      // :item?.displayLineItemPrice;

    result.push({
      name:   (!compareString(item?.productName, "additional") && compareString(item?.productName, "extender")) ? `${item?.productName} - ${wifiCount} count` : compareString(item?.productName,"whole") ?  `${item?.productName} ${wifiCount > 1 ? `- ${wifiCount > 2 ? 2 : wifiCount} extenders` : ""}` : item?.productName,
      price: `$${ !compareString(item?.productName, "additional") && compareString(item?.productName, "extender") ? (Math.abs(price)/Number(item.quantity)*wifiCount)?.toFixed(2): Math.abs(price)?.toFixed(2)} `,
    });
    
    // Check for "fiber" and integrate results from extractGigProducts
    if (item?.productName?.toLowerCase().includes("fiber") || item?.productName?.toLowerCase().includes("brightspeed now")) {
      // const gigFlag = item?.productName?.toLowerCase().includes("1 gig") ? "1 gig" : "2 gig";
      const gigFlag = item?.productName?.toLowerCase()?.substring(15,);
       const extractedGigProducts = extractGigProducts(productRes?.productResponse, gigFlag);
       extractedGigProducts?.forEach((gigProduct:any) => {
        result.push({
          name: gigProduct?.name,
          price: `-$${Math.abs(gigProduct?.amount)?.toFixed(2)}`,
        });
      });
    }
    else if (isAffinityDiscountApplicable && currentProduct?.offerResponse === undefined){
      let currentinternetProducts = existingOrderDetails && existingOrderDetails?.standardPlans?.length && existingOrderDetails?.standardPlans?.find((productList: any, i: any) => (
        productList?.ratePlanName?.toLowerCase().includes("fiber") || productList?.planName?.toLowerCase().includes("fiber") || productList?.ratePlanName?.toLowerCase().includes("instant") || productList?.productName?.toLowerCase().includes("instant"))
      )
      const gigFlagName = currentinternetProducts !== undefined && currentinternetProducts?.planName?.toLowerCase()?.substring(15,)
      const extractedGigProducts = extractGigProducts(productRes?.productResponse, gigFlagName);
      extractedGigProducts?.forEach((gigProduct:any) => {
       const discountVal = result?.find((names:any) => names?.name === gigProduct?.name);
       discountVal === undefined && 
       result.push({
         name: gigProduct?.name,
         price: `-$${Math.abs(gigProduct?.amount)?.toFixed(2)}`,
       });
     });
    }
    // if (planDetailsData && Array.isArray(planDetailsData) && planDetailsData?.length && (sameProd)) {
    //   planDetailsData.forEach((itemData: any) => {
    //     const exists = result?.some((entry) => entry?.name === itemData?.planName);
    //     if (!exists) {
    //       result.push({
    //         name: itemData?.planName,
    //         price: `-$${Math.abs(itemData?.planDiscount)?.toFixed(2)}`,
    //         validthru: itemData?.effectiveEndDate
    //       });
    //     }
    //   });
    // }

    let today = new Date();
    let nextMonth = new Date();
    nextMonth.setMonth(today.getMonth() + 1);
    let mm = nextMonth.getMonth() + 1;
    let dd = nextMonth.getDate();
    let yyyy = nextMonth.getFullYear();
    let validity = mm + '/' + dd + '/' + yyyy;

    let hasDiscount = Array.isArray(cartResponse?.discountResponses) ? cartResponse?.discountResponses.find((disItem:any)=>{
      return compareString(disItem?.productName,item?.productName)
    }):false;

    if(cartResponse && hasDiscount){
      result.push({
        name:"First Month Free" + " - " + item?.productName,
        price:`-$${Number(item?.displayTotalPrice || 0)?.toFixed(2)}`,
        validity:validity,
        type:"1mdiscount"
      })
    }
  });


  // Add tax if voiceRemoved is false and "voice" is in the cart
  if (!voiceRemoved) {
    const voiceInCart = cartResponse?.lineItems?.some((item: any) =>
      item?.productName?.toLowerCase().includes("voice")
    );
    const vasInCart = cartResponse?.lineItems?.some((item: any) =>
      item?.productName?.toLowerCase().includes("brightspeed total home tech support")
    );
      let taxamount = cartResponse?.totalTaxToday || cartResponse?.taxDetails?.taxedPrice?.totalGross?.centAmount || "0"
    if (voiceInCart || vasInCart || taxamount > 0) {
      
      result.push({
        name: csm,
        price: `$${Math.abs(taxamount)?.toFixed(2)}`,
      });
    }
  }
    if ((existingWifiExtender !== null && existingWifiExtender !== undefined) && existingWifiExtender?.quantity < wifiCount) {
    if (Array.isArray(existingWifiExtender?.allDiscount)) {
      existingWifiExtender?.allDiscount.filter((item:any) => {
        !compareString(item?.planName, "one month free") &&
          !item?.planName?.toLowerCase()?.includes("first month free-wifi extender") &&
          result.push({
            name: item?.planName,
            price: `-$${Number(item?.discountAmount || 0)?.toFixed(2)}`,
            validity: item?.effectiveEndDate,
            case: "Prepaid B"
          })
      })
    }
  }
  // Sort result by priority: fiber, voice, tech, tax
const planNames = Array.isArray(planDetailsData)
  ? planDetailsData.map((item) => item?.planName?.toLowerCase())
  : [];

const discountPriority = (sameProd) ?  planNames : isAffinityApplicable ? ["discount"] : planNames;

const priority = [
  "fiber",
  "brightspeed now",
  "mbps",
  "credit",
  ...discountPriority, // Ensures discounts or planNames are correctly inserted
  "voice - standard",
  "whole",
  "extender",
  "protection",
  "tech",
  "tax"
];

const sortedUniqueResult = result?.slice()
  .filter((item, index, self) => index === self.findIndex((t) => t.name === item.name)) // Removes duplicates
  .sort((a, b) => {
    const getPriorityIndex = (item: any) => {
      if (!item?.name) return Infinity;
      const lowerName = item?.name.toLowerCase();
      const index = priority?.findIndex((p) => lowerName?.includes(p));
      return index === -1 ? Infinity : index; // Ensures unmatched items go last
    };

    return getPriorityIndex(a) - getPriorityIndex(b);
  });
  
return sortedUniqueResult;
}

export const getFilteredItemsPostpaid = (
  cartResponse: any,
  existingOrderDetails: any,
  voiceRemoved: boolean,
  currentProduct: any,
  csm: any,
  productRes: any,
  planDetailsData?: any,
  selectedInternetProduct?:any,
  isAffinityApplicable?: any,
  selectedInternetChanged?: boolean,
  wifiCount?:any,
  ctlPlanDetails?:any,
  internetProductExist?:boolean
) => {
  const keywords = ["fiber internet", "fiber voice", "digital voice","tech",WHOLE_HOME_WIFI,WIFI_EXTENDER,THIC,"protection"];
  let result: any[]= [];
   const existingInternet = existingOrderDetails?.standardPlans?.find((element:any) => element?.productName?.toLowerCase().includes("internet"));
  let sameProd= selectedInternetProduct && Array.isArray(selectedInternetProduct) && selectedInternetProduct.length > 0 ? (selectedInternetProduct[0]?.productName?.toLowerCase()?.includes(existingInternet?.planName?.toLowerCase())): selectedInternetChanged === false ? true : false;
  const isAffinityDiscountApplicable = existingOrderDetails?.discountPlans?.find((element:any) => element?.productName === "Affinity Discount")?.affinityOccupation;
  // Determine the source of items based on voiceRemoved
  // below commneted code is not required aa cancel voice condtion changed from API end
  // const source = voiceRemoved
  //   ? [currentProduct?.offerResponse?.offerDetails]
  //   : cartResponse?.lineItems;

  const source = cartResponse?.lineItems;

  // Filter items from cartResponse or currentProduct based on keywords
  const availableFromCart = source?.filter((item: any) =>
    keywords?.some((keyword) => item?.productName?.toLowerCase().includes(keyword.toLowerCase()))
  );

  // Check for missing keywords in cart and handle them
  keywords?.forEach((keyword) => {
    const keywordInCart = availableFromCart?.some((item: any) =>
      item?.productName?.toLowerCase()?.includes(keyword?.toLowerCase())
    );

    // If not found in availableFromCart, look in existingOrderDetails
    if (!keywordInCart) {
      const sourceType = (keyword === "tech" || keyword===THIC ||  keyword === "protection" || keyword===WIFI_EXTENDER || keyword===WHOLE_HOME_WIFI) ? "additionalPlans" :  "standardPlans";
      
      let additonalPlan = existingOrderDetails?.additionalPlans
      additonalPlan = additonalPlan && additonalPlan.length ? additonalPlan.reduce((acc: any, item: any) => {
        const found = acc.find((obj: any) => obj?.additionalPlanName === item?.additionalPlanName);
        if (found) {
          found.count++
        } else {
          acc.push({ ...item, count:item?.quantity?item.quantity:1 })
        }
        return acc;
      }, []) : [];
     
      const planSource =
        (keyword === "tech" || keyword === THIC || keyword === "protection" || keyword===WIFI_EXTENDER || keyword===WHOLE_HOME_WIFI)
          ? additonalPlan
          : existingOrderDetails?.standardPlans;
      const plan = planSource?.find((plan: any) =>
        ((keyword === "tech" || keyword === THIC ||  keyword === "protection" || keyword===WIFI_EXTENDER || keyword===WHOLE_HOME_WIFI)) ?
      plan?.additionalPlanName?.toLowerCase()?.includes(keyword?.toLowerCase())
      :
      plan?.ratePlanName?.toLowerCase()?.includes(keyword?.toLowerCase())

      );
      
      if (plan && !(keyword === "voice" && voiceRemoved)) {
        // Use ctlPlanDetails price for internet only for current plan (productExist or internet not changed)
        const isInternetKeyword = keyword === "fiber internet";
        const isCurrentPlan = internetProductExist === true || selectedInternetChanged === false;
        const internetPriceFromCtl = isInternetKeyword && isCurrentPlan && ctlPlanDetails?.[0]?.internet?.amount ? ctlPlanDetails?.[0]?.internet?.amount : plan?.planPrice;
        
        result.push({
          name: ((keyword === "tech" || keyword === THIC ||  keyword === "protection" || keyword===WIFI_EXTENDER || keyword===WHOLE_HOME_WIFI)) ? 
          
          plan?.additionalPlanName//item?.productName?.includes(BRIGHT_SPEED_THTS) ? item?.productName?.replace("Brightspeed","") : item?.productName, item?.productName + ` - ${wifiCount} extenders`
 
          : plan?.ratePlanName,
          // discount:plan?.discount,
          // discountedPrice:     plan?.additionalPlanPrice - plan?.discount,
          // discountName:     plan?.allDiscount,
          // validity:plan?.validity, 333222222222222222222222223
          price: sourceType !== "additionalPlans" ? `$${Math.abs(internetPriceFromCtl)?.toFixed(2)}` :  `$${(Math.abs(plan?.additionalPlanPrice)?.toFixed(2))}`,
        });
      }

    if(Array.isArray(plan?.allDiscount) && plan?.allDiscount?.length > 0) {
      plan?.allDiscount?.forEach((item:any) => {
        if(!item?.planName?.toLowerCase()?.includes("first month free-wifi extender")) {
        result.push({
          name:item?.planName,
          type:"discount",
          price:`-$${Number(item?.discountAmount || 0)?.toFixed(2)}`,
          validity:item?.effectiveEndDate
        })
        }
      })
    }

    if (Array.isArray(plan?.discount) && plan?.discount?.length > 0) {
      plan?.discount?.forEach((item: any) => {
        if(item?.Disccode?.toLowerCase().includes("3mf")){
       result.push({
          name:"Three Months Free"+ " - "+item?.productName,
          price:`-$${Number(item?.Discvalue || 0)?.toFixed(2)}`,
          validity:""+item?.Discenddate?.replace(/\./g, "/"),
          type:"discount",
          code:"3mf"
      })
        }
      })
    }

  }

  });
  
    if (planDetailsData && Array.isArray(planDetailsData) && planDetailsData?.length && (sameProd)) {
      planDetailsData.forEach((itemData: any) => {
        const exists = result?.some((entry) => entry?.name === itemData?.planName);
        if (!exists) {
          result.push({
            name: itemData?.planName,
            type:"discount",
            price: `-$${Math.abs(itemData?.planDiscount)?.toFixed(2)}`,
          });
        }
      });
    }


  // Add all matching items from the cart to the result
  availableFromCart?.forEach((item: any) => {
    if (voiceRemoved && item?.productName?.toLowerCase().includes("voice")) {
      return;
    }
     

    if(cartResponse && (compareString(item?.productName,THIC) || compareString(item?.productName,"protection"))  && item.itemActionType==="delete"){
      return;
    }
    if(cartResponse && (compareString(item?.productName,"WiFi Extender"))  && wifiCount ===0 && item.itemActionType==="delete"){
      return;
    }
    if(cartResponse && compareString(item?.productName,"support") && item.itemActionType==="delete"){
      return;
    }
     if(cartResponse && compareString(item?.productName,"whole") && wifiCount ===0 && item.itemActionType==="delete"){
      return;
    }
    const price = item?.displayTotalPrice;
    //*********** Below code is not required */
    //const price = voiceRemoved
      // ? item?.priceResult?.length > 0 && item?.priceResult[0]?.productCharge || 0
      // :item?.displayLineItemPrice;

    // Use ctlPlanDetails price for internet only for current plan (productExist or internet not changed)
    const isInternetItem = item?.productName?.toLowerCase().includes("fiber") && (item?.productName?.toLowerCase().includes("internet") || item?.productName?.toLowerCase().includes("mbps") || item?.productName?.toLowerCase().includes("gig"));
    const isCurrentPlan = internetProductExist === true || selectedInternetChanged === false;
    const internetPrice = isInternetItem && isCurrentPlan && ctlPlanDetails?.[0]?.internet?.amount ? ctlPlanDetails?.[0]?.internet?.amount : price;

    result.push({
      name: getPostpaidLineItemName(item, wifiCount),
      price: getPostpaidLineItemPrice(item, internetPrice, wifiCount),
    });
    
    // Check for "fiber" and integrate results from extractGigProducts
    if (item?.productName?.toLowerCase().includes("fiber")) {
      // const gigFlag = item?.productName?.toLowerCase().includes("1 gig") ? "1 gig" : "2 gig";
      const gigFlag = item?.productName?.toLowerCase()?.substring(15,);
       const extractedGigProducts = extractGigProducts(productRes?.productResponse, gigFlag);
       extractedGigProducts?.forEach((gigProduct:any) => {
        result.push({
          name: gigProduct?.name,
          price: `-$${Math.abs(gigProduct?.amount)?.toFixed(2)}`,
        });
      });
    }
    else if (isAffinityDiscountApplicable && currentProduct?.offerResponse === undefined){
      let currentinternetProducts = existingOrderDetails && existingOrderDetails?.standardPlans?.length && existingOrderDetails?.standardPlans?.find((productList: any, i: any) => (
        productList?.ratePlanName?.toLowerCase().includes("fiber") || productList?.planName?.toLowerCase().includes("fiber") || productList?.ratePlanName?.toLowerCase().includes("instant") || productList?.productName?.toLowerCase().includes("instant"))
      )
      const gigFlagName = currentinternetProducts !== undefined && currentinternetProducts?.planName?.toLowerCase()?.substring(15,)
      const extractedGigProducts = extractGigProducts(productRes?.productResponse, gigFlagName);
      extractedGigProducts?.forEach((gigProduct:any) => {
       const discountVal = result?.find((names:any) => names?.name === gigProduct?.name);
       discountVal === undefined && 
       result.push({
         name: gigProduct?.name,
        type:"discount",
         price: `-$${Math.abs(gigProduct?.amount)?.toFixed(2)}`,
       });
     });
    }

    
    
    // if (planDetailsData && Array.isArray(planDetailsData) && planDetailsData?.length && (sameProd)) {
    //   planDetailsData.forEach((itemData: any) => {
    //     const exists = result?.some((entry) => entry?.name === itemData?.planName);
    //     if (!exists) {
    //       result.push({
    //         name: itemData?.planName,
    //         price: `-$${Math.abs(itemData?.planDiscount)?.toFixed(2)}`,
    //         validthru: itemData?.effectiveEndDate
    //       });
    //     }
    //   });
    // }

let today = new Date();
let nextMonth = new Date();
nextMonth.setMonth(today.getMonth() + 1);
let mm = nextMonth.getMonth() + 1;
let dd = nextMonth.getDate();
let yyyy = nextMonth.getFullYear();
let validity = mm + '/' + dd + '/' + yyyy;

    if(cartResponse &&  Number(item?.displayTotalDiscount || 0)!==0 && (compareString(item?.productFamily,"addOn"))){
     result.push({
          name:"First month free"+ " - "+item?.productName,
          price:`-$${Number(item?.displayTotalDiscount || 0)?.toFixed(2)}`,
          validity:validity,
          type:"1mdiscount"
        })
    }
  });


  // Add tax if voiceRemoved is false and "voice" is in the cart
  if (!voiceRemoved) {
    const voiceInCart = cartResponse?.lineItems?.some((item: any) =>
      item?.productName?.toLowerCase().includes("voice")
    );
    const vasInCart = cartResponse?.lineItems?.some((item: any) =>
      item?.productName?.toLowerCase().includes("brightspeed total home tech support")
    );
    let taxamount = cartResponse?.totalTaxToday || cartResponse?.taxDetails?.taxedPrice?.totalGross?.centAmount || "0"
 
    if (voiceInCart || vasInCart || taxamount > 0) {
      result.push({
        name: csm,
        price: `$${Math.abs(taxamount || 0)?.toFixed(2)}`,
      });
    }
  }
  // Sort result by priority: fiber, voice, tech, tax
const planNames = Array.isArray(planDetailsData)
  ? planDetailsData.map((item) => item?.planName?.toLowerCase())
  : [];

const discountPriority = (sameProd) ?  planNames : isAffinityApplicable ? ["discount"] : planNames;



const priority = [
  "fiber",
  "mbps",
  "credit",
  ...discountPriority, // Ensures discounts or planNames are correctly inserted
  "voice - standard",
  "whole",
  "extender",
  "protection",
  "tech",
  "tax"
];

const sortedUniqueResult = result?.slice()
  .filter((item, index, self) => index === self.findIndex((t) => t.name === item.name)) // Removes duplicates
  .sort((a, b) => {
    const getPriorityIndex = (item: any) => {
      if (!item?.name) return Infinity;
      const lowerName = item?.name.toLowerCase();
      const index = priority?.findIndex((p) => lowerName?.includes(p));
      return index === -1 ? Infinity : index; // Ensures unmatched items go last
    };

    return getPriorityIndex(a) - getPriorityIndex(b);
  });
  
return sortedUniqueResult;
}


export const calculateDiscountAmount = (
  isAffinityApplicable: boolean,
  productDetail: any,
  defaultVoipCard: boolean,
  convertDollarFn: (value: any) => string
): { discountAmount: string; discountAmountWithoutDollar: number } => {
  if (!defaultVoipCard && isAffinityApplicable) {
    const actualCharge = productDetail?.priceResult[0]?.actualCharge || '00';
    const discountAmount = convertDollarFn(actualCharge);
    return {
      discountAmount,
      discountAmountWithoutDollar: parseFloat(discountAmount.replace("$", "")) || 0,
    };
  }
  return { discountAmount: '00', discountAmountWithoutDollar: 0 };
};

export const determineRegularPrice = (
  isAffinityApplicable: boolean,
  productDetail: any,
  defaultVoipCard: boolean
): number => {
  if (!defaultVoipCard && isAffinityApplicable) {
    return productDetail?.priceResult[0]?.productCharge || 0;
  }
  return !defaultVoipCard && (productDetail !== null || productDetail !== undefined) ? productDetail?.priceResult?.[0]?.productCharge : 0;
};



export const saveProductInCartStateUtil = (
  product: any,
  productDetail: any,
  activeAccordion: number,
  defaultVoipCard: boolean,
  isAffinityApplicable: boolean,
  discountAmount: any
) => {
  if (!defaultVoipCard) {
    const ProductName = productDetail?.productName || '';
    const RegularPrice = (!defaultVoipCard && productDetail?.priceResult[0]?.productCharge) || 0;
    const price = ((!defaultVoipCard && RegularPrice) || 0);
    const discountName = !defaultVoipCard && isAffinityApplicable ? productDetail?.affinity?.discountName : '';
    const ProductPrice = convertDollarPriceNoTrailingZeros(price);

    switch (activeAccordion) {
      case 1:
        return {
          internetProductId: productDetail?.billingRateProductId,
          internetProductName: ProductName,
          internetProductPrice: ProductPrice,
          discountAmount,
          discountName,
          isAffinityFromCatalogue: isAffinityApplicable,
        };
        
      case 2:
        return {
          // discountAmount,
          // discountName,
          // internetProductId: productDetail?.billingRateProductId,
          // internetProductName: ProductName,
          // internetProductPrice: ProductPrice,
          // isAffinityFromCatalogue: isAffinityApplicable,
          voipProductId: product?.billingRateProductId,
          voipProductName: ProductName,
          voipProductPrice: ProductPrice,
          installationProductName: ProductName,
          installationProductPrice: ProductPrice,
        };
        
      // case 3:
      //   return {
      //     voipProductId: product?.billingRateProductId,
      //     voipProductName: ProductName,
      //     voipProductPrice: ProductPrice,
      //     installationProductName: ProductName,
      //     installationProductPrice: ProductPrice,
      //   };

      default:
        return {};
    }
  } else {
    return {
      voipProductName: '',
      voipProductPrice: '',
    };
  }
};

// Normalize speed so that equivalent speeds map to the same value
// e.g., 940000 (940 Mbps actual) → 1000000 (1 Gig marketed)
function normalizeSpeed(speed: number): number {
  if (speed === 940000) return 1000000;
  return speed;
}

// Helper to extract speed from plan name (e.g., "1 Gig", "500 Mbps")
function extractSpeedFromPlanName(planName: string): number | null {
  if (!planName) return null;
  const lower = planName.toLowerCase();
  if (lower.includes("gig")) {
    const match = lower.match(/(\d+)\s*gig/);
    if (match) return parseInt(match[1], 10) * 1000000;
    if (lower.includes("2 gig")) return 2000000;
    if (lower.includes("5 gig")) return 5000000;
    if (lower.includes("8 gig")) return 8000000;
    if (lower.includes("1 gig")) return 1000000;
  }
  if (lower.includes("mbps")) {
    const match = lower.match(/(\d+)\s*mbps/);
    if (match) return parseInt(match[1], 10) * 1000;
  }
  return null;
}
function checkProductExist(existingProduct: any, cardType: string, product: any, isPostPaidFiberUser: boolean) {
	const existingProductMap: {
		[key: string]: number
	} = {};
	// Create a lookup table for existing products
	existingProduct?.forEach((item: any, index: number) => {
		if (isPostPaidFiberUser) existingProductMap[item?.productId] = index;
		else existingProductMap[item?.productRatePlanId] = index;
	});
	let currentProductRatePlanId: any;
	if (cardType === "internet") {
		// Use find() to find the matching offerResponse
		let matchingOffer = product && product?.findIndex((offer: any) => {
			currentProductRatePlanId = isPostPaidFiberUser ? offer?.offerResponse?.offerDetails?.billingProductId : offer?.offerResponse?.offerDetails?.billingRateProductId;
			return existingProductMap[currentProductRatePlanId] !== undefined;
		});
    // If not found by productId, try to match by speed in plan name
    if(matchingOffer === -1 && product?.length > 0 && existingProduct?.length > 0){
      matchingOffer = product?.findIndex((offer: any) => {
        const offerSpeed = offer?.speed;
        // Try to match with any existing product's planName speed
        return existingProduct.some((item: any) => {
          const planName = item?.planName || item?.productName;
          const planSpeed = extractSpeedFromPlanName(planName);
          return planSpeed && offerSpeed && normalizeSpeed(planSpeed) === normalizeSpeed(offerSpeed);
        });
      });
    }
		if (matchingOffer >= 0) {
			const existIndex = matchingOffer
			return {
				productExist: true,
				existIndex: existIndex
			};
		}
	} else if (cardType === "voice") {
		const matchingOffer = product && product?.findIndex((offer: any) => {
			currentProductRatePlanId = isPostPaidFiberUser ? offer?.billingProductId : offer?.billingRateProductId;
			return existingProductMap[currentProductRatePlanId] !== undefined;
		});
		if (matchingOffer >= 0) {
			const existIndex = matchingOffer
			return {
				productExist: true,
				existIndex: existIndex
			};
		}
	}
	return {
		productExist: false,
		existIndex: -1
	};
}

function checkExistingProductSupplement(serviceDetails: any, cardType: any, product: any) {
  const internetPlan = serviceDetails?.subscriptions?.[0]?.serviceDetails?.find((item: any) => item.isParent?.toUpperCase() === "TRUE" &&
    ["FIBER INTERNET"].includes(item?.serviceType?.toUpperCase()) && (item?.serviceState?.toUpperCase() === "INSTALLATION PENDING" || item?.serviceState?.toUpperCase() === "ACTIVE"));
  let serviceLevel = internetPlan?.serviceModel;
  const voicePlan = serviceDetails?.subscriptions?.[0]?.serviceDetails?.find((item: any) => item.isParent?.toUpperCase() === "TRUE" &&
    ["FIBER VOICE"].includes(item?.serviceType?.toUpperCase()) && (item?.serviceState?.toUpperCase() === "INSTALLATION PENDING" || item?.serviceState?.toUpperCase() === "ACTIVE"));
  let voiceServiceLevel = voicePlan?.serviceModel;
  if (cardType === "internet" && serviceLevel) {
    const matchingOffer = product && product?.findIndex((offer: any) => offer?.offerResponse?.offerDetails?.billingProductId === serviceLevel);
    if (matchingOffer >= 0) {
      const existIndex = matchingOffer
      return {
        productExist: true,
        existIndex: existIndex
      };
    }
  }
   if (cardType === "voice") {
		 const matchingOffer = product && product?.findIndex((offer: any) => {
      return offer?.billingProductId  === voiceServiceLevel;});
		if (matchingOffer >= 0) {
			const existIndex = matchingOffer
			return {
				productExist: true,
				existIndex: existIndex
			};
		}
	}
  return {
    productExist: false,
    existIndex: -1
  };
}

function getInstallType(brsdIndicator: string) {
  brsdIndicator = brsdIndicator?.toUpperCase();
  if (brsdIndicator === "BF_QUALIFIED" || brsdIndicator === "QUALIFIED" || brsdIndicator === "QF_QUALIFIED" || brsdIndicator === "QF QUALIFIED") {
    return "self";
  } else {
    return "";
  }
}

function getAddressType(brightSpeedFiberIndicator: string) {
  brightSpeedFiberIndicator = brightSpeedFiberIndicator?.toUpperCase();
  if (brightSpeedFiberIndicator === 'BF_QUALIFIED' || brightSpeedFiberIndicator === 'QUALIFIED') {
    return "bs";
  } else if (brightSpeedFiberIndicator === 'QF_QUALIFIED' || brightSpeedFiberIndicator === 'QF QUALIFIED') {
    return "qf";
  } else if (brightSpeedFiberIndicator === 'COPPER') {
    return "ctl";
  } else {
    return "";
  }
}

const compareCurrentPlanName = (currentInternetPlan:any, internetPlan:any) => {
  
  const planName = currentInternetPlan?.planName
  const productName = currentInternetPlan?.productName
  if ((compareString(planName, internetPlan) || compareString(productName, internetPlan))) {
    return true
  }
  return false
}

let enableWifi7 = process.env.REACT_APP_ENABLE_WIFI7 === "true";
let existingProductCheck = null;
let existingInternetSpeed = 0; 
const getProductStatus = (currentProductIndex: number, index: number, isProductExist: boolean,existingProducts:any,cardType="internet",product?:any, isPostPaidFiberUser?:boolean, isSupplementOrderEligible?:boolean) => {
  if (currentProductIndex === -1 ) {
    return { recommended: false, productExist: false };
  }
  const recommended =(currentProductIndex - 1) === index;
  let isSpeedDowngradingAllowed = true;
  const newplan8G = product && product?.speed?.toString() === "8000000";
  const newplan5G = product && product?.speed?.toString() === "5000000";
  const productExist = (currentProductIndex === index && isProductExist);
  const planName= existingProducts?.find((products:any) => {return ((products?.planName?.toLowerCase().includes(cardType))?. planName) || (products?.productName?.toLowerCase().includes(cardType)) && !products?.productName?.toLowerCase()?.includes("voicemail") })?.productName ;
  const has8gOR5G = planName?.toLowerCase().includes("8 gig") || planName?.toLowerCase().includes("5 gig");
  const plansWithPrices = existingProducts?.find((products:any) => {return products?.planName?.toLowerCase().includes(cardType) || products?.productName?.toLowerCase().includes(cardType) || products?.planName?.toLowerCase().includes("brightspeed now") && !products?.productName?.toLowerCase()?.includes("voicemail")})?.planPrice;

  if (isPostPaidFiberUser) {
    if (enableWifi7 && !isSupplementOrderEligible) {
      const internetProduct = existingProducts?.filter((item: any) => { return ((item?.ratePlanName?.toLowerCase()?.includes("internet") || item?.productName?.toLowerCase()?.includes("internet")) && item) });
      let productId = isPostPaidFiberUser ? internetProduct?.[0]?.productId : internetProduct?.[0]?.productRatePlanId;
          
      if (isPostPaidFiberUser) {        
        if(product?.offerResponse?.offerDetails?.billingProductId === productId) {
          existingProductCheck = product;
          existingInternetSpeed = existingProductCheck?.speed;
        }
      } else {
        if(product?.offerResponse?.offerDetails?.billingRateProductId === productId) {
          existingProductCheck = product;
          existingInternetSpeed = existingProductCheck?.speed;
        }        
      }  
     
      if(product?.speed < existingInternetSpeed) {
        isSpeedDowngradingAllowed = false
      }
    }
    else {
      const currentInternetPlan = existingProducts?.find((products: any) => { return (products?.planName?.toLowerCase().includes(cardType) || products?.productName?.toLowerCase().includes(cardType)) });
      //  if (checkHasObject(currentInternetPlan) === true){
      if (compareCurrentPlanName(currentInternetPlan, "2 gig") || compareCurrentPlanName(currentInternetPlan, "8 gig")) {
        isSpeedDowngradingAllowed = false
      } else if ((compareCurrentPlanName(currentInternetPlan, "5 gig") && newplan8G === false)) {
        isSpeedDowngradingAllowed = false
      } else if ((compareCurrentPlanName(currentInternetPlan, "1 gig") && product?.speed !== 2000000)) {
        isSpeedDowngradingAllowed = false
      } else if (((compareCurrentPlanName(currentInternetPlan, "500 mbps") || compareCurrentPlanName(currentInternetPlan, "600 mbps")) && product?.speed !== 2000000 && product?.speed !== 1000000 && product?.speed !== 940000)) {
        isSpeedDowngradingAllowed = false
      } else if (((compareCurrentPlanName(currentInternetPlan, "300 mbps") || compareCurrentPlanName(currentInternetPlan, "200 mbps")) && (product?.speed !== 2000000 && product?.speed !== 1000000 && product?.speed !== 940000 && product?.speed !== 500000))) {
        isSpeedDowngradingAllowed = false
      }
    }
  }
  return { recommended, productExist, plansWithPrices,newplan8G,has8gOR5G,newplan5G,planName,isSpeedDowngradingAllowed };
};



const isConditionsMet = (
  lnpDetails: any,
  isLnpChoosen: string,
  productFlag: boolean,
  lnp: boolean,
  mandatory: boolean,
  voipServiceLimitationAgreement: boolean,
  cancelFlow: boolean,
 ): boolean => {
  const currentLineItem = lnpDetails?.currentLineItem || {};
  const hasValidLineItem = currentLineItem.id !== "" || currentLineItem.productCode !== "";
  return (
    ((currentLineItem?.productCode !== "" || currentLineItem.productCode !== undefined) && !productFlag && !cancelFlow) && 
    ((hasValidLineItem && isLnpChoosen === "Yes" && !lnp && !mandatory) || 
    (hasValidLineItem && isLnpChoosen === "Yes" && !lnpDetails.requiredFields) ||
    (hasValidLineItem && isLnpChoosen === "No"  && !voipServiceLimitationAgreement))
  );
 };

export const getCardClassName = (

  cardType: string,
  voiceRemoved: boolean,
  productExist: boolean,
  selectedProductDetail: any,
  productDetail: any,
  recommendedProduct: any,
   styles: any,
   newplan8G: any
 ) => {

  const classes = ["cardChild", styles["AvailableProducts__card"], styles.regularCard, "regularCard"];
 
  // Determine active/inactive state

  const isActiveProduct = productDetail?.productCode === selectedProductDetail?.productCode;

  if (

    (cardType !== "voice" && isActiveProduct) ||

    (cardType === "voice" && !voiceRemoved && isActiveProduct)

  ) {

    classes.push("card-active");

  } else {

    classes.push("card-inactive");

  }
 
  // Determine currentCard state

  if (

    ((selectedProductDetail?.productCode === "" || selectedProductDetail?.productCode === undefined) &&

      productExist &&

      cardType !== "voice") ||

    (cardType === "voice" && !voiceRemoved && productExist)

  ) {

    classes.push("card-active", "currentCard");

  } else {

    classes.push("card-inactive");

  }
 
  // Add currentCard if product exists

  if (productExist) {

    classes.push("currentCard");

  }
 
  // Add selectedCard

  if (selectedProductDetail?.productCode === productDetail?.productCode && !productExist) {

    classes.push("selectedCard");

  }
 
  // Add recommendedCard

  if (recommendedProduct) {

    classes.push("recommendedCard");

  }
    // 8G Product 
  if (newplan8G && !productExist) {

    classes.push("newCard");

  }
 
  // Add family and key-based classes

  if (isActiveProduct) {

    classes.push(`${productDetail?.productFamily}Card`);

    classes.push(`${productDetail?.productFamily}Card${productDetail?.key}`);

  }
 
  return classes.filter(Boolean).join(" ");

};
const replaceJSX = (text: any, find1: any, replace1: any, find2 = '', replace2 = '', find3 = '', replace3 = '', find4 = '', replace4 = '', find5 = '', replace5 = '') => {
  const output = text && text?.split(find1).flatMap((item: any) => [item, replace1]);
  output?.pop();
  if (find2 && replace2 && output[output?.length - 1]) {
    const output2 = output[output?.length - 1]
      .split(find2)
      .flatMap((item: any) => [item, replace2]);
    output2?.pop();
    output?.pop();
    if (find3 && replace3) {
      const output3 = output2?.pop()?.split(find3).flatMap((item: any) => [item, replace3]);
      output3?.pop();
      if (find4 && replace4) {
        const output4 = output3?.pop()?.split(find4).flatMap((item: any) => [item, replace4]);
        output4?.pop();
        if (find5 && replace5) {
          const output5 = output4?.pop()?.split(find5).flatMap((item: any) => [item, replace5]);
          output5?.pop();
          return [...output, ...output2, ...output3, ...output4, ...output5];
        }
        return [...output, ...output2, ...output3, ...output4];
      }
      return [...output, ...output2, ...output3];
    }
    return [...output, ...output2];
  }
  return output;

};

const getForIQRemove=(prevCart:any,updateCartResp:any)=>{
  let res;

  if(!Array.isArray(prevCart?.lineItems)){
    return updateCartResp;
  }
  if(!Array.isArray(updateCartResp?.lineItems)){
    return updateCartResp;
  }

  /*
  findIQ -  prevCart value has to remove THIC  
  findIQUpdate -  next updateCart  value has no remove THIC   
  */
 
  let findIQ = prevCart.lineItems.find((item:any)=>compareString(item.productName,"controls") && item.itemActionType==="remove");
  let findIQUpdate = updateCartResp.lineItems.find((item:any)=>compareString(item.productName,"controls") && item.itemActionType===undefined);

  let findTHTS = prevCart.lineItems.find((item:any)=>compareString(item.productName,"support") && item.itemActionType==="remove");
  let findTHTSUpdate = updateCartResp.lineItems.find((item:any)=>compareString(item.productName,"support") && item.itemActionType===undefined);

  let _updateCart=updateCartResp;

  if(findTHTS===undefined){
    res=updateCartResp;
  }

  /* case 1 if prev cart has nothing regarding thic remove return the latest updateCart api response */  
  if(findIQ===undefined){
    res=updateCartResp;
  }
  /* case 2 if next updateCart  has nothing regarding thic remove return the latest updateCart api response */
  else if(findIQUpdate===undefined){
    res=updateCartResp;
  }
  /* 
  case 3 if prevcart  has regarding thic remove and next update cart has nothing regarding THIC remove without change in thic section
  then - update the thic lineitem with prev thic lineitem
  */

  if(findIQ!==undefined && findIQUpdate!==undefined){

    _updateCart.lineItems=_updateCart?.lineItems?.map((item:any)=>{
      if(compareString(item?.productName,"controls")){
        item=findIQ;
      }
      return item;
    })
    res=_updateCart;
  }


  if(findTHTS!==undefined && findTHTSUpdate!==undefined){

    _updateCart.lineItems=_updateCart?.lineItems?.map((item:any)=>{
      if(compareString(item?.productName,"support")){
        item=findTHTS;
      }
      return item;
    })
    res=_updateCart;
  }
  return res;
}

const getVoiceToadd=(cart:any,existing:any)=>{
  let sendvoiceToAdd=false;
  let voiceToAdd = cart?.lineItems?.find((item:any)=>compareString(item?.productName,"voice"));
  let voiceExist = existing?.standardPlans?.find((item:any)=>compareString(item?.ratePlanName,"voice"));


  if(voiceExist===undefined && voiceToAdd!==undefined){
    sendvoiceToAdd=true;
  }

  return sendvoiceToAdd;
}

const checkIfWeHaveOweToday=(selectedInternetProduct:any,selectedVoiceProduct:any,hasTHTS:any,hasTHIC:any,internetExist:any,cancelFlow:any)=>{
  let haveOwe=false;
  if (selectedInternetProduct && Object.keys(selectedInternetProduct)?.length > 0 && !internetExist) {
    selectedInternetProduct?.map((productList: any, i: any) => {
      if (productList?.productName?.toLowerCase()?.includes("fiber")){
        haveOwe=true;
      }
    });
  }
  if (selectedVoiceProduct &&  (Object.keys(selectedVoiceProduct)?.length > 0 && !cancelFlow)) {
    selectedVoiceProduct?.map((productList: any, i: any) => {
      if(productList?.productName?.toLowerCase()?.includes("voice")){
        haveOwe=true;
      }
    })
  }

  if(hasTHTS){
    haveOwe=true;
  }
  if(hasTHIC){
    haveOwe=true;
  }

  return haveOwe;
}

const priceFormatter = (price: number | false): string => {
  if (price === false) return "$0.00";

  let decimalVal= price?.toString()?.split(".") ;

   return decimalVal?.[1] === undefined ? `${price}.00` : `${price}`
};

const checkForPrmaryPay=(listOfPayMethods:any)=>{
  let selected=null;
  selected = listOfPayMethods?.creditcard?.filter((item:any)=>{
    return item.isDefault===true;
  });

  if(selected===null || (Array.isArray(selected) && selected.length===0)){
    selected=listOfPayMethods?.bankAccounts?.filter((item:any)=>{
      return item.isDefault===true;
    });
  }
  let card=null;
  
  if(selected && Array.isArray(selected) && selected.length>0){
    card=selected[0];
  }
  return card;
}

// True when the subscription API returns any expired VAS discount (BRIM or Zuora).
const hasExpiredVasDiscount = (subScriptionPlanDetails?: any) =>
  (subScriptionPlanDetails?.expiredBrimVasDiscountsSet?.length || 0) > 0 ||
  (subScriptionPlanDetails?.expiredZuoraVasDiscountPlans?.length || 0) > 0;

const fixAddonForPostpaid=(data:any,code:any,subScriptionPlanDetails?:any)=>{
  let child= data?.product?.productGroups?.find((inner:any)=>{
    return inner.productCode==code;
  });
  if((process.env.REACT_APP_VAS_1MF_ENABLED ?? "true").toLowerCase() === "true"){
    child?.childProducts?.forEach((item:any) => {
      if (item?.attributeCategory && Array.isArray(item?.attributeCategory?.records)) {
        item?.attributeCategory?.records.forEach((i:any) => {
          if (i?.productAttributes && Array.isArray(i?.productAttributes?.records)) {
            i?.productAttributes?.records.forEach((c:any) => {
              if (compareString(c?.closerOfferCode, "1MF")) {
                data.hasOneMonth = true;
                if(compareString(c?.closerOfferDetails, "whole") || compareString(c?.closerOfferDetails, "additional wifi extender")){
                  data.hasWholeHomeWifi = true;
                  data.whwOfferCode=c?.closerOfferCode;
                }
                if(compareString(c?.closerOfferDetails, "protection") || compareString(c?.closerOfferDetails, "iq")){
                  data.hasWifiProtection = true;
                  data.protectionOfferCode=c?.closerOfferCode;
                }
                if(compareString(c?.closerOfferDetails, "total home") || compareString(c?.closerOfferDetails, "asurion")){
                  data.hasTHTS = true;
                  data.thtsOfferCode= c?.closerOfferCode;
                } 
                if((compareString(c?.closerOfferDetails,"wifi extender") || compareString(c?.closerOfferDetails,"extender" )) && !compareString(c?.closerOfferDetails,"additional wifi extender" ) ){
                  data.hasWifiExtender = true;
                }
              }
            });
          }
        });
      }
    });
  }

  data.product.productGroups=[...data.product.productGroups,...child.childProducts]
  // data.product.productGroups=[...data.productGroups,...child.childProducts];
  // No 1MF offer when the account already has an expired VAS discount from the subscription API.
  if (hasExpiredVasDiscount(subScriptionPlanDetails)) {
    data.hasOneMonth = false;
  }
 return data;
}


const fixAddonForPrepaid=(data:any,code:any,subScriptionPlanDetails?:any)=>{
  let child= data?.product?.productGroups;
  if((process.env.REACT_APP_VAS_1MF_ENABLED ?? "true").toLowerCase() === "true"){
    child?.forEach((ck:any) => {
    ck?.childProducts?.forEach((item:any) => {
      if (item?.attributeCategory && Array.isArray(item?.attributeCategory?.records)) {
        item?.attributeCategory?.records.forEach((i:any) => {
          if (i?.productAttributes && Array.isArray(i?.productAttributes?.records)) {
            i?.productAttributes?.records.forEach((c:any) => {
              if (compareString(c?.closerOfferCode, "1-MONTH-DISCOUNT-CODE")) {
                data.hasOneMonth = true;
                if(compareString(c?.closerOfferDetails, "whole") || compareString(c?.closerOfferDetails, "additional wifi extender")){
                  data.hasWholeHomeWifi = true;
                  data.whwOfferCode=c?.closerOfferCode;
                }
                if(compareString(c?.closerOfferDetails, "protection") || compareString(c?.closerOfferDetails, "iq")){
                  data.hasWifiProtection = true;
                  data.protectionOfferCode=c?.closerOfferCode;
                }
                if(compareString(c?.closerOfferDetails, "total home") || compareString(c?.closerOfferDetails, "asurion")){
                  data.hasTHTS = true;
                  data.thtsOfferCode= c?.closerOfferCode;
                } 
                if((compareString(c?.closerOfferDetails,"wifi extender") || compareString(c?.closerOfferDetails,"extender" )) && !compareString(c?.closerOfferDetails,"additional wifi extender" ) ){
                  data.hasWifiExtender = true;
                }
              }
            });
          }
        });
      }
    });
    });
  }

  // data.product.productGroups=[...data.product.productGroups,...child.childProducts]
  // data.product.productGroups=[...data.productGroups,...child.childProducts];
  // No 1MF offer when the account already has an expired VAS discount from the subscription API.
  if (hasExpiredVasDiscount(subScriptionPlanDetails)) {
    data.hasOneMonth = false;
  }
 return data;
}


const extractFiberPlan=(name:any)=>{
  let temp=name.split(" ");
  let plangig=""
  temp.forEach((item:any,i:number)=>{
    if(!isNaN(item)){
      plangig+=item+" "+temp[i+1]
    }
  })
  return plangig;
}

const extractFiberPlanName=(name:any)=>{
  let temp=name.split(" ")
  .filter((item:any)=>!compareString(item,"brightspeed"))
  .filter((item:any)=>isNaN(item));
  temp.pop()
  return temp.join(" ");
}

/**
 * 
 * @param text Text to insert a React component on
 * @param find Token to replace with a React component
 * @param children A React child component to insert
 * @returns A text component with a child component. Must be called inside a JSX.
 */
const replaceWithComponent = (text: string, find: string, children: React.ReactNode) => {
  const parts = text.split(find)
  return (
    <>
      {parts.length > 1 ? (
        <>
          {parts[0]}
          {children}
          {parts[1]}
        </>
      ) : (
        text
      )}
    </>
  )
}

export function orderHasFromMove(serviceDetails:any) {
  const orders = Array.isArray(serviceDetails?.order)
    ? serviceDetails.order
    : [];
  return orders.some(
    (item: any) => item?.orderType?.toUpperCase() === "FROM",
  );
}

export const filterProductsForBulkProperty = (products: any[], existingPlans: any[]) => {
  if (!products?.length || !existingPlans?.length) return products;

  // Find the existing internet plan from subscription data
  const currentInternetPlan = existingPlans.find((plan: any) => {
    const planName = (plan?.planName || plan?.productName || "").toLowerCase();
    const ratePlanName = (plan?.ratePlanName || "").toLowerCase();
    return planName.includes("internet") || planName.includes("fiber") ||
      planName.includes("instant") || planName.includes("brightspeed now") ||
      ratePlanName.includes("internet") || ratePlanName.includes("fiber") ||
      ratePlanName.includes("instant");
  });

  if (!currentInternetPlan) return products;

  // Try to match the existing plan to a product in the catalogue by ID to get the speed
  const planProductId = currentInternetPlan?.productId;
  const planRatePlanId = currentInternetPlan?.productRatePlanId;

  const matchedProduct = products.find((p: any) => {
    const billingProductId = p?.offerResponse?.offerDetails?.billingProductId;
    const billingRateProductId = p?.offerResponse?.offerDetails?.billingRateProductId;
    return (planProductId && billingProductId === planProductId) ||
      (planRatePlanId && billingRateProductId === planRatePlanId);
  });

  let bulkPlanSpeed: number | null = null;

  if (matchedProduct) {
    bulkPlanSpeed = matchedProduct?.speed;
  } else {
    // Fallback: try to extract speed from plan name
    const planName = currentInternetPlan?.planName || currentInternetPlan?.productName || "";
    bulkPlanSpeed = extractSpeedFromPlanName(planName);
  }

  if (!bulkPlanSpeed) return products;

  const normalizedBulkSpeed = normalizeSpeed(bulkPlanSpeed);

  // Sort products by speed ascending to find tiers in order
  const sortedProducts = [...products].sort((a: any, b: any) => normalizeSpeed(a?.speed || 0) - normalizeSpeed(b?.speed || 0));

  // Find the current plan product and the next tier up only
  const currentPlanProduct = sortedProducts.find((p: any) => normalizeSpeed(p?.speed || 0) === normalizedBulkSpeed);
  const nextTierProduct = sortedProducts.find((p: any) => normalizeSpeed(p?.speed || 0) > normalizedBulkSpeed);

  const currentPlanPrice = currentPlanProduct?.offerResponse?.offerDetails?.priceResult?.[0]?.productCharge || 0;

  const result: any[] = [];

  if (currentPlanProduct) {
    // Current plan shows at $0 for bulk property
    const currentClone = JSON.parse(JSON.stringify(currentPlanProduct));
    currentClone.offerResponse.offerDetails.priceResult[0].productCharge = 0;
    result.push(currentClone);
  }

  if (nextTierProduct) {
    // Next tier shows the differential price (next tier price - current plan price)
    const nextClone = JSON.parse(JSON.stringify(nextTierProduct));
    const nextTierPrice = nextClone?.offerResponse?.offerDetails?.priceResult?.[0]?.productCharge || 0;
    nextClone.offerResponse.offerDetails.priceResult[0].productCharge = nextTierPrice - currentPlanPrice;
    result.push(nextClone);
  }

  return result;
};

export const shouldCarryForwardPrepaidExtenderDiscount = (existingQuantity: any, selectedQuantity: any): boolean => {
  const originalCount = Number(existingQuantity);
  const selectedCount = Number(selectedQuantity ?? existingQuantity);
  return Number.isFinite(originalCount) && Number.isFinite(selectedCount)
    && originalCount > 0 && selectedCount >= originalCount;
};


 
 
export { formatProductName, checkProductExist, getInstallType, getAddressType,priceFormatter, getProductStatus, isConditionsMet, replaceJSX, getForIQRemove, getVoiceToadd, checkIfWeHaveOweToday,checkForPrmaryPay,fixAddonForPostpaid,extractFiberPlan,
  checkExistingProductSupplement,extractFiberPlanName, replaceWithComponent,fixAddonForPrepaid};
